import { useSelector } from "react-redux";
import { getUrlQuerysection } from "../../../../../../helpers";
import { useUrlSearch } from "../../../../../../hooks/useUrlSearch";
import { purchaseOrderStatus } from "../../../../../../localdata";
import {
  useGetBills,
  useGetSuppliers,
} from "../../../../../../hooks/api/queries";
import { useEffect } from "react";

export const useAllBills = () => {
  const { storeList } = useSelector((state) => state.profileDetailsReducer);
  const queries = getUrlQuerysection();
  const {
    search,
    gotoPage,
    filterByStoreId,
    filterBySearch,
    filterByKey,
    filterByDate,
  } = useUrlSearch();

  const { isLoading: isLoadingBills, data } = useGetBills({ queries });
  const { data: suppliers, isLoading: isLoadingSupplier } = useGetSuppliers();

  useEffect(() => {
    if (!search.get("status")) filterByKey("status", "IN_REVIEW");
  }, []);

  return {
    isLoadingExtra: isLoadingSupplier,
    isLoadingBills,
    bills: data?.data || [],
    metaDetails: data?.meta,
    search,
    storeList,
    billsStatus: (() => {
      const status = [...purchaseOrderStatus];
      status[0] = { label: "Approved", value: "APPROVED" };

      return status;
    })(),
    suppliers: suppliers || [],
    filterByDate,
    filterByStoreId,
    filterBySearch,
    gotoPage,
    filterByKey,
  };
};
